var productTagcs = document.getElementsByClassName('livearf-product-tags')[0]?.getAttribute("data-tags") || "";
var isFixedSizeProductcs = productTagcs.includes("orientation");
const giftSection = document.getElementsByClassName('rich-text__blocks center');
if (!isFixedSizeProductcs && giftSection) {
  console.log('inside gift section')
  document.querySelectorAll(".rich-text__blocks").forEach(el => {
  if (el.textContent.includes("A FRAMED PRINT")) {
    el.style.display = "none";
  }
});
document.querySelectorAll(".rich-text__text.rte").forEach(el => {
    el.style.display = "none";
  });
}
const sizeLegend = document.querySelector('fieldset[name="Size"] legend');
if (sizeLegend) {
  sizeLegend.textContent = "Image Size";
}

if(isFixedSizeProductcs){
   localStorage.clear();
  document.querySelectorAll('.product__title h1').forEach(h1 => {
  const h2 = document.createElement('h2');
  h2.innerHTML = h1.innerHTML;
  h2.className = h1.className;
  h1.replaceWith(h2);
});
  // setTimeout(() => {
  //               let productFormQuantity = document.querySelector(".product-form__quantity");
  //               frameSpecs = document.querySelector(".your_frame_specs");

  //               if (!frameSpecs) {
  //                   frameSpecs = document.createElement("div");
  //                   frameSpecs.classList.add("your_frame_specs");
  //                   frameSpecs.innerHTML = `<p class="frame_editor_summary"> Outer Dimensions: <span class="frame_options_exterior_width_text">${Number(currentSize.width) + 2*(Number(currentSize.frameThickness))+ Number(currentSize.firstMatSize)}</span>" x <span class="frame_options_exterior_height_text">${Number(currentSize.height) + 2*(Number(currentSize.frameThickness)) + Number(currentSize.firstMatSize)}</span>" </p> <p class="editor_paper_size_line"> Image Size: <span class="frame_options_art_width_text">${Number(currentSize.width)}</span>" x <span class="frame_options_art_height_text">${Number(currentSize.height)}</span>"  &nbsp; <a href="#mat_window_opening_modal" class="customSize" style="display:none" title="Edit the mat window opening"><img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLTF6P_bGoUfZOk0AdOWKC47uFGNdhublm0A&s" alt="Edit" style="width: 16px; height: 16px; vertical-align: middle;"></a></p><p class="editor_inner_dim"> Mat Total Dimension: <span class="frame_options_inner_width_text">${Number(currentSize.width) + Number(currentSize.firstMatSize)}</span>" x <span class="frame_options_inner_height_text">${Number(currentSize.height) + Number(currentSize.firstMatSize)}</span>"</p>`;
  //                   productFormQuantity.insertAdjacentElement("beforebegin", frameSpecs);
  //               }
  //           }, 500);

     setTimeout(() => {
                let productFormQuantity = document.querySelector(".product-form__quantity");
                frameSpecs = document.querySelector(".your_frame_specs");
                if (!isFixedSizeProduct) {
                    frameSpecs.style.display = 'none'
                }
                if (!frameSpecs) {
                    frameSpecs = document.createElement("div");
                    frameSpecs.classList.add("your_frame_specs");
                    frameSpecs.innerHTML = `<p class="outerDim"> Outer Dimensions: <span class="outerWidth">${Number(currentSize.width) + 2 * (Number(currentSize.frameThickness)) +2 * ( Number(currentSize.firstMatSize))}</span>" x <span class="outerHeight">${Number(currentSize.height) + 2 * (Number(currentSize.frameThickness)) + 2 * (Number(currentSize.firstMatSize))}</span>" </p>
                     <p class="imageSize"> Image Size: <span class="imageWidth">${Number(currentSize.width)}</span>" x <span class="imageHeight">${Number(currentSize.height)}</span>"  &nbsp; <a href="#mat_window_opening_modal" class="customSize" style="display:none" title="Edit the mat window opening"><img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLTF6P_bGoUfZOk0AdOWKC47uFGNdhublm0A&s" alt="Edit" style="width: 16px; height: 16px; vertical-align: middle;"></a></p>
                     <p class="matTotalDim"> Mat Total Dimension: <span class="matWidth">${Number(currentSize.width) + 2 * (Number(currentSize.firstMatSize))}</span>" x <span class="matHeight">${Number(currentSize.height) + 2 * (Number(currentSize.firstMatSize))}</span>"</p>`;
                    productFormQuantity.insertAdjacentElement("beforebegin", frameSpecs);
                }
            }, 500);

    let selectedOrientation = "portrait";
function createOrientationToggle(){
  const sizeFieldset = document.querySelector('fieldset[name="Size"]');
  if(!sizeFieldset) return;
  if(document.getElementById("orientation-toggle")) return;
  const toggleHTML = `
  <div class="liveraf-toggle-container" id="orientation-toggle">
      <span id="liveraf-portraitLabel" class="liveraf-toggle-label liveraf-active">Portrait</span>
      <label class="liveraf-switch">
          <input type="checkbox" id="liveraf-toggleSwitch">
          <span class="liveraf-toggle-slider"></span>
      </label>
      <span id="liveraf-landscapeLabel" class="liveraf-toggle-label">Landscape</span>
  </div>
  `;
  sizeFieldset.insertAdjacentHTML("beforeend", toggleHTML);
  initOrientationToggle();
}
function initOrientationToggle(){
  const toggleSwitch = document.getElementById("liveraf-toggleSwitch");
  if(!toggleSwitch) return;
  toggleSwitch.addEventListener("change",function(){
      const isLandscape = this.checked;
      if(isLandscape){
          selectedOrientation="landscape";
          document.getElementById("liveraf-landscapeLabel").classList.add("liveraf-active");
          document.getElementById("liveraf-portraitLabel").classList.remove("liveraf-active");
      }else{
          selectedOrientation="portrait";
          document.getElementById("liveraf-portraitLabel").classList.add("liveraf-active");
          document.getElementById("liveraf-landscapeLabel").classList.remove("liveraf-active");
      }
      applyOrientation();
  });
}
function applyOrientation(){
  if(!window.currentSize) return;
  currentSize.orientation = selectedOrientation;
  doSizeChanges(
      currentSize.width,
      currentSize.height,
      selectedOrientation
  );
}
document.addEventListener("change",function(e){
  if(e.target.matches('fieldset[name="Size"] input[type="radio"]')){
      setTimeout(()=>{
          applyOrientation();
      },60);
  }
});
function initializeOrientation(){
  setTimeout(()=>{
      if(window.currentSize){
          currentSize.orientation = selectedOrientation;
          doSizeChanges(
              currentSize.width,
              currentSize.height,
              selectedOrientation
          );
      }
  },300);
}
window.addEventListener("load",function(){
  createOrientationToggle();
  initializeOrientation();
});
document.addEventListener("change", function(e){
  if(e.target && e.target.id === "image-upload"){
    setTimeout(()=>{
      if(window.currentSize){
        doSizeChanges(
          currentSize.width,
          currentSize.height,
          currentSize.orientation || selectedOrientation || "portrait"
        );
      }
    },800);
  }
});
}

const richText = document.querySelector('.rich-text__wrapper--right .center .rich-text__text');
const quantityDiv = document.querySelector('.product-form__quantity');

if (richText && quantityDiv) {
  quantityDiv.insertAdjacentElement('afterend', richText);
  richText.classList.add('after-quantity');
}